import React from "react";
import "./CTASection.css";


const CTASection = ({
  title = "Book Your Next Journey with Shreesha Tours & Travels",

description =
"Safe, reliable and affordable taxi services for airport transfers, local rides and outstation travel with professional chauffeurs.",

  buttonText = "Book Now",

  buttonLink = "/booking",

  termsLink = "/term-condition",

  expiry = "2 days, 14 hours",

  phone = "+91 83558 35813",

  backgroundImage = "/images/bg-img.jpg",

}) => {


return (

<section className="cta-wrapper">


<div

className="cta-box"

style={{
backgroundImage:`url(${backgroundImage})`
}}

>


<div className="cta-overlay"></div>



<div className="cta-content">



{/* Left */}


<div className="cta-left">


<div className="cta-title">


<div className="cta-lines">

<span></span>
<span></span>
<span></span>

</div>



<h2>
{title}
</h2>



</div>




<p className="cta-description">

{description}

</p>





<div className="cta-buttons">


<a

href={buttonLink}

className="cta-btn"

>

{buttonText}

<span>
📅
</span>


</a>




<a

href={termsLink}

className="terms-link"

>

View Terms

</a>


</div>



{/* 
<p className="expiry-text">

Offer expires in

<strong>
{expiry}
</strong>

</p> */}



</div>







{/* Right */}


<div className="cta-phone">


<span>
Call Us Now
</span>


<a

href={`tel:${phone.replace(/\s|-/g,"")}`}

>

{phone}

</a>


</div>





</div>



</div>



</section>

);


};


export default CTASection;